<ui-page-container>
  <mat-card class="media-page-content">
    <mat-card-title>{{ 'Utenti' | translate }}</mat-card-title>
    <mat-card-content>
      <ui-table
        [filters]="filters$ | async"
        [rowSelection]="'checkbox'"
        [fields]="fields"
        [reload]="reload$"
        [pager]="pager$"
        [itemsPage]="(page$ | async)?.current"
        [itemsPerPage]="(page$ | async)?.limit"
        [contextMenuActions]="contextMenus"
        (itemsPageChange)="applyChangePageHandler($event)"
        (select)="selectHandler($event)"
        (rowAction)="manageRowActions($event)">
        <div tableActions>
          <app-entity-actions
            className="User"
            [selectedItemsCount]="selectedItems?.length"
            [config]="{ showAddToCollection: false, showExport: false }"
            (add)="addHandler()"
            (delete)="deleteSelectedHandler()">
          </app-entity-actions>
        </div>
        <div tableFilters>
          <ui-filters
            [dialogFilters]="MobileFiltersComponent"
            (action)="applyFilterWithDelayHandler($event)">
            <app-filters #desktopFilter></app-filters>
          </ui-filters>
        </div>
      </ui-table>
    </mat-card-content>
  </mat-card>
</ui-page-container>
